import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ProjectPageName, ProjectStaticPageName } from "healthex-common/project.data.dtos";
import { ProtocolType } from "healthex-common/study.dtos";
import { asEnum, willNeverHappen } from "healthex-common/utils";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../../Infra/display-name";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { AlertDialogText } from "../AddProjectJoinCommon/AddJoinCommonComponents";
import { AddJoinCommonInformedConsentPreviewView } from "../AddProjectJoinCommon/InformedConsent/AddJoinCommonInformedConsentPreviewView";
import { AddJoinCommonInformedConsentTranslationsView } from "../AddProjectJoinCommon/InformedConsent/AddJoinCommonInformedConsentTranslationsView";
import { ImagePreviewDialog } from "../FilePreview";
import { FilePreviewDialog } from "../FileUploadView.styles";
import { HXSimpleDialog } from "../HXSimpleDialog";
import { MultiPagePDFViewer } from "../MutiPagePDFViewer";
import { NoDataCardView } from "../NoDataCardView";
import { useViewModel } from "../useViewModel";
import { AddProjectMainView } from "./AddProjectMainView";
import { AddProjectPagesView } from "./AddProjectPagesView";
import { AddProjectViewModel } from "./AddProjectViewModel";
import { AddStudyConflictDetectionDialog } from "./ConflictDetection/AddStudyConflictDetectionDialog";
import { AddProjectSidePanel } from "./SidePanel/AddProjectSidePanel";
export const AddProjectView = observer((props) => {
    const model = useViewModel(AddProjectViewModel, props.container);
    const [imagePreviewOpen, setImagePreviewOpen] = React.useState(false);
    const [imageUrl, setImageUrl] = React.useState(null);
    const [imageFilename, setImageFilename] = React.useState(null);
    const [imageCaption, setImageCaption] = React.useState(null);
    const handleViewImage = (imgUrl, filename, caption) => {
        setImagePreviewOpen(true);
        setImageUrl(imgUrl);
        setImageFilename(filename);
        setImageCaption(caption !== null && caption !== void 0 ? caption : null);
    };
    if (model.study !== NOT_LOADED && !model.myStudyUser) {
        return (_jsx(NoDataCardView, { title: "You have not been added to this project", buttons: [
                {
                    secondary: true,
                    children: "Go home",
                    onClick: () => model.navigateToHome(),
                },
            ], margin: "64px" }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(AddProjectMainView, { container: props.container, model: model, sidePanel: _jsx(AddProjectSidePanel, { container: props.container }), pagesView: renderPage() }), _jsx(HXSimpleDialog, { open: model.informedConsentLockedDialogModel.open, onClose: (choice) => model.informedConsentLockedDialogModel.onChoice(choice), buttons: [
                    ["GO_TO_OVERVIEW", "Go to Overview"],
                    ["SAVE_AND_EXIT", "Save and exit"],
                ], title: "Informed consent section is currently locked by another user", children: _jsx(AlertDialogText, { children: "Another team member is currently deciding how to build the informed consent experience. You won\u2019t be able to enter information in this section until their decision is made. You can either continue working in a different section or save your progress and return later." }) }), _jsx(HXSimpleDialog, { open: model.majorChangesDialogModel.open, onClose: (choice) => model.majorChangesDialogModel.onChoice(choice), buttons: [
                    model.majorChangesDialogModel.changesType === "COMPLETED_ADDING"
                        ? ["GOTO_STUDY_MANAGER", "Go to Study Manager"]
                        : ["RELOAD", "Reload study"],
                ], title: model.majorChangesDialogTitle, children: _jsx(AlertDialogText, { children: model.majorChangesDialogText }) }), _jsx(FilePreviewDialog, { open: !!model.protocolDocumentUrl, onClose: () => model.closeProtocolDocumentDownloadUrl(), buttons: [], closeChoice: false, title: `Preview: ${model.protocolType === ProtocolType.ICF_PROTOCOLS ? model.icfProtocolFileName : model.studyProtocolFileName}`, children: model.protocolDocumentUrl && _jsx(MultiPagePDFViewer, { url: model.protocolDocumentUrl }) }), _jsx(AddStudyConflictDetectionDialog, { container: props.container }), _jsx(ImagePreviewDialog, { open: imagePreviewOpen && imageUrl !== null && imageFilename !== null, onClose: () => setImagePreviewOpen(false), filename: imageFilename, url: imageUrl, caption: imageCaption !== null && imageCaption !== void 0 ? imageCaption : undefined })] }));
    function renderPage() {
        var _a;
        const route = (_a = model.currentPage) !== null && _a !== void 0 ? _a : "";
        const pageName = asEnum(ProjectPageName)(route);
        const staticPageName = asEnum(ProjectStaticPageName)(route);
        if (pageName) {
            return _jsx(AddProjectPagesView, { model: model, container: props.container, onViewImage: handleViewImage });
        }
        if (staticPageName) {
            switch (staticPageName) {
                case ProjectStaticPageName.TRANSLATIONS:
                    return (_jsx(AddJoinCommonInformedConsentTranslationsView, { container: props.container, addProjectUIManager: model.addProjectUIManager, onViewImage: handleViewImage }));
                case ProjectStaticPageName.PREVIEW:
                    return (_jsx(AddJoinCommonInformedConsentPreviewView, { container: props.container, addProjectUIManager: model.addProjectUIManager }));
                default:
                    willNeverHappen(staticPageName);
            }
        }
        return _jsx(_Fragment, {});
    }
});
addDisplayName(AddProjectView, "AddProjectView");
